import React from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import DeleteIcon from '@material-ui/icons/Delete'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Grid from '@material-ui/core/Grid'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Zoom from '@material-ui/core/Zoom'
import SendIcon from '@material-ui/icons/Send'
import Paper from '@material-ui/core/Paper'
import PortableWifiOffIcon from '@material-ui/icons/PortableWifiOff'
import WifiTetheringIcon from '@material-ui/icons/WifiTethering'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import * as constants from '../../../constants'
import { RenjuBoardCard, ChatCard, TitleGrid, ControlCard, Word } from '../../../containers'
import { makePath } from '../../../lib';
import Fade from '@material-ui/core/Fade';
import { WID } from '../../../constants/Language';
import { useEffect } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { types } from '../../../constants/ActionTypes'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  grid: {
    width: '100%',
    maxWidth: '1000px',
    margin: '24px auto',
  },
  gridTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.text.secondary,
  },
  circularProgress: {
    margin: '100px auto',
  },
  wifiTetheringIcon: {
    marginRight: theme.spacing.unit,
  },
  fixedButtons: {
    display: 'flex',
    position: 'fixed',
    bottom: theme.spacing.unit,
    right: theme.spacing.unit,
  },
  buttonBox: {
    marginLeft: theme.spacing.unit * 2,
  },
  button: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  contributor: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing.unit,
    width: 24,
    height: 24,
  },
  contributorName: {
    color: theme.palette.grey['600'],
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  title: {
    marginLeft: theme.spacing.unit,
  },
});

class BoardTabs extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.tabId !== this.props.tabId ) {
      return true
    }
    else {
      return false
    }
  }

  render() {
    const { theme, tabId, tabProps, onChange } = this.props
    
    return (
    <div style={{width: '100%', maxWidth: 680, display:'flex', margin:`${theme.spacing.unit}px auto`}}>
      <Paper style={{width: '100%'}}>
        <Tabs
          value={tabId}
          onChange={onChange}
          indicatorColor="primary"
          textColor="primary"
          scrollable
          scrollButtons="on"
        >
          {tabProps.length > 0 && tabProps.map((props, index) => 
            <Tab label={props.label} key={index}/>
          )}
        </Tabs>
      </Paper>
    </div>
  )}
}

BoardTabs = withStyles(styles, { withTheme: true })(BoardTabs)

function LiveGame(props) {
  const { classes, theme, tabId, tabProps, liveStatus, liveId, contributor, openConfirmDialog, isVisibleBoard, isVisibleChat, enableSendButton, enableEndButton, enableRestartButton, enableDeleteButton, handleClickSendButton, handleClickEndButton, handleClickRestartButton, handleClickDeleteButton, handleCloseConfirmDialog, handleOK, handleChangeTab, handleOpenBoard, handleOpenAnalyzeTab } = props

  const [isInitialized, setIsInitialized] = useState(false)
  
  const dispatch = useDispatch()

  const history = useHistory()

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  }
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const match = useRouteMatch(`*/live/:id`)

  useEffect(() => {
    if (!isInitialized) {
      dispatch({ type: types.live.INITIALIZE, liveId: match.params.id })
      setIsInitialized(true)
    }
    if (props.socket) {
      props.init()
      props.joinLiveRoom()
    }
    return () => {
      props.leaveLiveRoom()
    }
  }, [props.socket])

  useEffect(() => {
    var timeoutID
    if (liveStatus === constants.liveStatus.DELETE) {
      timeoutID = setTimeout(() => {
        history.push(makePath('/live', language))
      }, 1000)
    }
    return () => {
      if (timeoutID) {
        clearTimeout(timeoutID)
      }
    }
  }, [liveStatus])

  return (
    <div className={classes.root}>
      <TitleGrid titleType='live'>
        {!isVisibleBoard && !isVisibleChat && (
          <Grid item xs={12} style={{display: 'flex'}}>
            <CircularProgress className={classes.circularProgress}/>
          </Grid>
        )}
        <Grid item xs={12} md={7}>
          <Fade in={isVisibleBoard && isVisibleChat}>
            <div>
              <BoardTabs tabId={tabId} tabProps={tabProps} onChange={handleChangeTab(tabProps, tabId)}/>
              {tabProps.length > 0 && tabProps[tabId].bid >= 0 && (
                <RenjuBoardCard
                  bid={tabProps[tabId].bid}
                  isVisibleEditModeMenu={false}
                  onOpenAnalyzeTab={handleOpenAnalyzeTab(tabProps, tabId)}
                  customHeaderTitle={
                    tabProps[tabId].boardType === constants.boardType.LIVE_GAME &&
                    liveStatus === constants.liveStatus.OPEN ? (
                      <div className={classes.titleBox}>
                        <FiberManualRecordIcon color='secondary'/>
                        <Typography className={classes.title} variant='title' color='secondary'>LIVE</Typography>
                      </div>
                    ) : (<div></div>)
                  }
                />
              )}
            </div>
          </Fade>
        </Grid>
        <Grid item xs={12} md={5}>
          {tabProps[tabId] !== undefined && tabProps[tabId].bid !== undefined && (
            <ControlCard bid={tabProps[tabId].bid}/>
          )}
          <Fade in={isVisibleBoard && isVisibleChat}>
            <div style={{maxWidth: 680, margin: '0 auto'}}>
              {tabProps[tabId] && tabProps[tabId].bid >= 0 && (
                <ChatCard bid={tabProps[tabId].bid} liveId={liveId} onOpenBoard={handleOpenBoard(tabProps, tabId)}/>
              )}
            </div>
          </Fade>
        </Grid>
        <Grid item xs={12}>
          {contributor && isVisibleBoard && isVisibleChat && (
            <React.Fragment>
            <div className={classes.contributor}>
              <Typography className={classes.contributorName}><Word wid={WID.LIVE_GAME.CONTRIBUTOR_LABEL}/>{' :'}</Typography>
              <CustomAvatar
                alt={contributor.displayName}
                name={contributor.displayName}
                src={contributor.photoURL}
                className={classes.avatar}
              />
              <Typography className={classes.contributorName}>{contributor.displayName}</Typography>
            </div>
            </React.Fragment>
          )}
        </Grid>
        <Grid item xs={12} style={{textAlign: 'center', height: '100px'}}>
        </Grid>
      </TitleGrid>
      <div className={classes.fixedButtons}>
        <Zoom
            in={enableSendButton}
            timeout={transitionDuration}
            style={{
              transitionDelay: `${enableSendButton ? transitionDuration.exit : 0}ms`,
            }}
            unmountOnExit
        >
          <div className={classes.buttonBox}>
            <Typography align='center' color='primary'><Word wid={WID.LIVE_GAME.FIXED_BUTTONS.SEND}/></Typography>
            <Button variant="fab" className={classes.button} color="primary" onClick={handleClickSendButton}>
              <SendIcon/>
            </Button>
          </div>
        </Zoom>
        <Zoom
            in={enableEndButton}
            timeout={transitionDuration}
            style={{
              transitionDelay: `${enableEndButton ? transitionDuration.exit : 0}ms`,
            }}
            unmountOnExit
        >
          <div className={classes.buttonBox}>
            <Typography align='center' color='primary'><Word wid={WID.LIVE_GAME.FIXED_BUTTONS.FINISH}/></Typography>
            <Button variant="fab" className={classes.button} color="primary" onClick={handleClickEndButton(liveId)}>
              <PortableWifiOffIcon/>
            </Button>
          </div>
        </Zoom>
      </div>
      <div className={classes.fixedButtons}>
        <Zoom
            in={enableDeleteButton}
            timeout={transitionDuration}
            style={{
              transitionDelay: `${enableDeleteButton ? transitionDuration.exit : 0}ms`,
            }}
            unmountOnExit
        >
          <div className={classes.buttonBox}>
            <Typography align='center' color='primary'><Word wid={WID.LIVE_GAME.FIXED_BUTTONS.DELETE}/></Typography>
            <Button variant="fab" className={classes.button} color="primary" onClick={handleClickDeleteButton}>
              <DeleteIcon/>
            </Button>
          </div>
        </Zoom>
        <Zoom
            in={enableRestartButton}
            timeout={transitionDuration}
            style={{
              transitionDelay: `${enableRestartButton ? transitionDuration.exit : 0}ms`,
            }}
            unmountOnExit
        >
          <div className={classes.buttonBox}>
            <Typography align='center' color='primary'><Word wid={WID.LIVE_GAME.FIXED_BUTTONS.RESTART}/></Typography>
            <Button variant="fab" className={classes.button} color="primary" onClick={handleClickRestartButton(liveId)}>
              <WifiTetheringIcon/>
            </Button>
          </div>
        </Zoom>
      </div>
      <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
        <DialogTitle><Word wid={WID.LIVE_GAME.DELETE_CONFIRM_DIALOG.DIALOG_TITLE}/></DialogTitle>
        <DialogActions>
          <Button onClick={handleOK(liveId)} color="primary" autoFocus>
            OK
          </Button>
          <Button onClick={handleCloseConfirmDialog} color="primary" autoFocus>
            Canncel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withStyles(styles, { withTheme: true })(LiveGame)


// WEBPACK FOOTER //
// ./src/Pages/Live/components/LiveGame.js